var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp(target, key, result);
  return result;
};
import { html } from "lit";
import { property } from "lit/decorators.js";
import { OmniElement } from "../../omni-element.js";
import { styleMap } from "lit/directives/style-map.js";
import { when } from "lit/directives/when.js";
import { css } from "lit";
const styles = css`:host {
  position: relative;
}

div {
  display: flex;
  background-color: #e6ebf1;
  border-radius: 4px;
}
div.show-percent {
  margin-right: 30px;
}
div .bar {
  background-image: var(--gradient-primary);
  height: 12px;
  border-radius: 4px;
  transition: all 300ms ease-out;
}

span.percent {
  position: absolute;
  right: 0;
  top: -3px;
  font-size: 11px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: 0.24px;
  text-align: right;
  color: #a2a9ad;
}`;
class OmniProgressBar extends OmniElement {
  constructor() {
    super(...arguments);
    this.value = 0;
    this.percent = false;
  }
  static get styles() {
    return [...super.styles, styles];
  }
  render() {
    return html`
      <div class=${this.percent ? "show-percent" : ""}>
        <div class="bar" part="bar" style=${styleMap({ width: `${this.value}%` })}></div>
      </div>
      ${when(this.percent, () => html` <span class="percent">${this.value}%</span> `)}
    `;
  }
}
__decorateClass([
  property({ type: Number })
], OmniProgressBar.prototype, "value", 2);
__decorateClass([
  property({ type: Boolean, attribute: true, reflect: true })
], OmniProgressBar.prototype, "percent", 2);
OmniElement.register("omni-progress-bar", OmniProgressBar);
export {
  OmniProgressBar
};
//# sourceMappingURL=omni-progress-bar.js.map
